var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue } from "vue-property-decorator";
import { Component, Prop } from 'vue-property-decorator';
let CodigoFooter = class CodigoFooter extends Vue {
};
__decorate([
    Prop({ default: new Date().getFullYear().toString() }),
    __metadata("design:type", String)
], CodigoFooter.prototype, "copyRight", void 0);
__decorate([
    Prop({ default: "Digital Signage" }),
    __metadata("design:type", String)
], CodigoFooter.prototype, "productType", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], CodigoFooter.prototype, "fixed", void 0);
__decorate([
    Prop({ default: "/img/logo-small.png" }),
    __metadata("design:type", String)
], CodigoFooter.prototype, "footerLogo", void 0);
__decorate([
    Prop({ default: "/img/CodigoLoadingLoop.gif" }),
    __metadata("design:type", String)
], CodigoFooter.prototype, "loadingIcon", void 0);
CodigoFooter = __decorate([
    Component
], CodigoFooter);
export default CodigoFooter;
